import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'antd';

const BackToHomeButton = () => (
  <div
    style={{
      display: 'flex',
      flex: 1,
      alignItems: 'center',
      margin: '0 10px',
    }}
  >
    {/* eslint-disable-next-line no-return-assign */}
    <Button onClick={() => window.location.pathname = '/'} shape="round" size="large">
      <FontAwesomeIcon icon={faArrowLeft} />
    </Button>
  </div>
);

export default BackToHomeButton;
